import axios from 'axios';
import { EventType } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
/** This effect deletes axios tokens on logout. */
export const useAuthAxiosDeleteOnSignOutEffect = () => {
    const { instance } = useMsal();
    useEffect(() => {
        const id = instance.addEventCallback((message) => {
            if (message.eventType === EventType.LOGOUT_START) {
                delete axios.defaults.headers.Authorization; //other defaults?
            }
        });
        return () => {
            if (id) {
                instance.removeEventCallback(id);
            }
        };
    }, [instance]);
};
